import { observable, toJS } from 'mobx';
import { autobind } from 'core-decorators';
import BaseStore from '@src/utils/store/base-store';
import DropDownMenuStore from './dropDownMenu/store';
import { noop } from '@src/utils/common-util';
import { isFunction } from '@src/utils/type-utils';
import { SECTION_CONFIG } from '@src/pages/main/config';
import AntdMessage from '@src/components/antd/message';
import { DOWNLOAD_URL } from '@src/constants/business';


class NaviBarStore extends BaseStore {
  // 下拉菜单
  dropDownMenuStore = new DropDownMenuStore();
  // 导航项激活变化回调
  onNavActiveChange = noop;
  // 导航栏是否固定在顶部
  @observable isSticky = false;
  // 当前激活的导航项索引
  @observable activeIndex = 0;
  // 导航项列表（从 SECTION_CONFIG 获取 + 添加"关注我们"虚拟导航项）
  @observable
  navList = [
    ...Object.values(SECTION_CONFIG)
      .sort((a, b) => a.order - b.order)
      .map(item => ({ title: item.title })),
    { title: '关注我们', isVirtual: true } // 虚拟导航项，不对应独立 slide
  ];

  @observable downloadLink = DOWNLOAD_URL;

  onDownloadClick = () => {
    if (this.downloadLink) {
      window.open(this.downloadLink, '_blank');
    } else {
      AntdMessage.info('敬请期待');
    }
  };

  constructor(props = {}) {
    super();

    const { onNavActiveChange } = props;
    if (isFunction(onNavActiveChange)) {
      this.onNavActiveChange = onNavActiveChange;
    }
  }

  @autobind
  onNavClick(index) {
    this.activeIndex = index;
    this.onNavActiveChange?.(toJS(this.navList[index]), index);
  }

  use() {
    super.use();
  }
}

export default NaviBarStore;
